import { NewFeatureNotificationData } from '@ardoq/status-ui';

export const reportReaderNewFeaturesNotificationsData: NewFeatureNotificationData[] =
  [
    // {
    //   notificationKey:
    //     PersonalSetting.XXXXXX,
    //   notificationMessage: `You can now share filtered report views! Apply filters, then copy the report URL to give others the exact view they need - no duplicates, no extra setup.`,
    // },
  ];
